<template>
  <div>
    <div class="columns is-align-items-center is-marginless">
      <span class="column is-narrow">
        {{$t('societes.logistiqueImpression.libelleVisuel')}}
      </span>
      <span v-if="isDetail" class="has-text-weight-bold column is-1">
        {{ getValueDelai('delaiLivraisonVisuel') }}
      </span>
      <b-input v-else class="column is-1"
        type="number"
        :min="0"
        :use-html5-validation="false"
        v-model.number="retroplanning.delaiLivraisonVisuel">
      </b-input>
      <span class="column is-narrow">
        {{$t('societes.logistiqueImpression.infoDelai')}}
      </span>
    </div>
    <div class="columns is-align-items-center is-marginless">
      <span class="column is-narrow pdr-2">
        {{$t('societes.logistiqueImpression.libelleAfficheImprimee')}}
      </span>
      <span v-if="isDetail" class="has-text-weight-bold column is-1">
        {{ getValueDelai('delaiLivraisonAfficheImprimee') }}
      </span>
      <b-input v-else class="column is-1"
        type="number"
        :min="0"
        :use-html5-validation="false"
        v-model.number="retroplanning.delaiLivraisonAfficheImprimee">
      </b-input>
      <span class="column is-narrow">
        {{$t('societes.logistiqueImpression.infoDelai')}}</span>
    </div>
    <div class="columns is-align-items-center is-marginless">
      <span class="column is-narrow">
        {{$t('societes.logistiqueImpression.libelleAffichePreparee')}}
      </span>
      <span v-if="isDetail" class="has-text-weight-bold column is-1">
        {{ getValueDelai('delaiLivraisonAffichePreparee') }}
      </span>
      <b-input v-else class="column is-1"
        type="number"
        :min="0"
        :use-html5-validation="false"
        v-model.number="retroplanning.delaiLivraisonAffichePreparee">
      </b-input>
      <span class="column is-narrow">
        {{$t('societes.logistiqueImpression.infoDelai')}}</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    retroplanning: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    getValueDelai(field) {
      if (this.retroplanning[field]) return this.retroplanning[field];
      return 0;
    },
  },
};
</script>

<style>

</style>
